import { jsPDF } from "jspdf";

export interface LetterData {
    title: string;
    firstname: string;
    lastname: string;
    address: string;
    plz: number;
    city: string;
    senderFirstname: string;
    senderLastname: string;
    municipality: string;
}

export const createLetterPdf = () => {

    const createLetter = async (letters: LetterData[]) => {
        const doc = new jsPDF("p", "mm", "a4");

        let isFirstPage = true;

        for (const letter of letters) {
            if(!isFirstPage) {
                doc.addPage();
            }

            isFirstPage = false;

            const { municipality } = letter;

            if(municipality === 'Flims') {
                await createFlimsLetter(letter, doc);
            }

            if(municipality === 'Falera') {
                await createFaleraLetter(letter, doc);
            }

            if(municipality === 'Laax') {
                await createLaaxLetter(letter, doc);
            }
        }

        // Save the document
        doc.save("ea-versand.pdf");

    };

    const createLaaxLetter = async (letter: LetterData, doc: jsPDF) =>
    {
            const { title, firstname, lastname, address, plz, city, senderFirstname, senderLastname } = letter;

            doc.setFontSize(9);
            doc.setFont("Helvetica", "bold");
            doc.text("Controlla da habitonts", 120, 22, { align: "left" });
            doc.setFont("Helvetica", "normal");
            doc.text(" | Einwohnerkontrolle", 154, 22, { align: "left" });
            doc.text("Caum postal 16 · Via Principala 60c · CH-7031 Laax GR1", 120, 26, { align: "left" });

            const date = new Date();
            const day = date.getDate();
            const month = new Intl.DateTimeFormat('de-DE', { month: 'long' }).format(date);
            const year = date.getFullYear();
            const currentDate = `${day}. ${month} ${year}`;

            doc.setFontSize(10);
            doc.setFont("Helvetica", "normal");
            doc.text(title, 120, 60, {align: "left" });
            doc.text(firstname + ' ' + lastname, 120, 64, { align: "left" });
            doc.text(address, 120, 68, { align: "left" });
            doc.text(plz + ' ' + city, 120, 72, { align: "left" });

            doc.text('Laax' + ', ' + currentDate, 120, 88, { align: "left" });

            // Subject
            doc.setFont("Helvetica", "bold");
            doc.setFontSize(13);
            doc.text("Einheimisch-Ausweis", 25, 120);

            // Greeting
            doc.setFontSize(11);
            doc.setFont("Helvetica", "normal");
            const preTitle = ({ Herr: "geehrter", Frau: "geehrte" })[title as string] || "";

            doc.text("Sehr " + preTitle + ' ' + title + ' ' + lastname, 25, 130);

            // Body Content
            const bodyText = [
                "In der Beilage überlassen wir Ihnen den neuen Einheimisch-Ausweis.",
                "Er ist fünf Jahre gültig (s. rechter Kartenrand).",
                "",
                "Den Einheimisch-Ausweis können Sie u.a. für die verschiedensten Dienstleistungen einsetzen:",
                "",
                "- als Bestätigung des Einheimischstatus",
                "- Einheimischrabattierung in Geschäften (falls angeboten)",
                "- Bezug von vergünstigten Abonnements und Tickets bei den Bergbahnen",
                "- Mehrheitlich kostenloser öV Transport innerhalb der Destination Flims, Laax und Falera",
                "- Einheimischtarife bei öffentlichen Angeboten (Laaxersee, Caumasee, wellnessHostel3000 etc.)",
            ];
            doc.text(bodyText, 25, 140, { maxWidth: 190, align: "left", lineHeightFactor: 1.25 });
            const bodyTextBeforeLink = "Unter ";
            const linkText = "www.einheimisch-ausweis.ch";
            const bodyTextAfterLink = " finden Sie weitere Erläuterungen.";

            const yPosition = 191;
            doc.text(bodyTextBeforeLink, 25, yPosition, { maxWidth: 190, align: "left" });

            const xLinkStart = doc.getTextWidth(bodyTextBeforeLink) + 25;

            doc.setTextColor(0, 0, 255);
            doc.setFont("Helvetica", "normal");
            doc.text(linkText, doc.getTextWidth(bodyTextBeforeLink) + 25, yPosition);

            doc.setFont("Helvetica", "normal");
            doc.setTextColor(0, 0, 0);
            doc.text(bodyTextAfterLink, doc.getTextWidth(bodyTextBeforeLink) + doc.getTextWidth(linkText) + 25, yPosition, {
                maxWidth: 190,
                align: "left",
            });

            const linkWidth = doc.getTextWidth(linkText);
            doc.setDrawColor(0, 0, 255); // Set line color to blue
            doc.line(xLinkStart, yPosition + 1, xLinkStart + linkWidth, yPosition + 1);

            // Closing
            doc.setFont("Helvetica", "normal");
            doc.text("Freundliche Grüsse", 120, 220);
            doc.setFont("Helvetica", "bold");
            doc.text("Einwohnerkontrolle Laax", 120, 225);
            doc.setFont("Helvetica", "normal");
            doc.text(senderFirstname + ' ' + senderLastname, 120, 237);
    };

    const createFaleraLetter = async (letter: LetterData, doc: jsPDF) =>
    {
        const { firstname, lastname, address, plz, city, senderFirstname, senderLastname } = letter;

        const date = new Date();
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const currentDate = `${day}.${month}.${year}`;

        doc.setFont("Helvetica", "normal");
        doc.setFontSize(10);

        doc.setFont("Helvetica", "normal");
        doc.text(firstname + ' ' + lastname, 120, 52, { align: "left" });
        doc.text(address, 120, 56, { align: "left" });
        doc.text(plz + ' ' + city, 120, 60, { align: "left" });

        doc.text('Falera' + ', ' + currentDate, 120, 84, { align: "left" });

        // web
        doc.setTextColor(0, 0, 255);
        const webText = "www.falera.net";
        const emailText = "info@falera.net";
        const webTextWidth = doc.getTextWidth(webText);
        const emailTextWidth = doc.getTextWidth(emailText);
        doc.line(25, 70, 26 + webTextWidth, 70);
        doc.line(25, 74, 26 + emailTextWidth, 74);

        doc.setFont("Helvetica", "bold");
        doc.text(webText, 25, 70);
        doc.text(emailText, 25, 74);

        doc.setTextColor(0, 0, 0);

        // Subject
        doc.setFontSize(13);
        doc.text("Attest d‘indigens / Einheimisch-Ausweis", 25, 104);

        // Greeting
        doc.setFont("Helvetica", "normal");

        doc.setFontSize(10);
        // Body Content
        const bodyText = [
            "Aschuntau survegnis Vus Vies niev attest d’indigens. El vala tschun onns (mira agl ur dretg dalla carta).",
            "",
            "Cun quella carta saveis Vus profitar denter auter dallas suandontas prestaziuns:",
            "",
            "    - sco confirmaziun da Vies status d’indigens",
            "    - abonnaments e bigliets favoreivels tier las pendicularas Flem-Laax-Falera",
            "    - per gronda part via libra cun il traffic public enteifer la destinaziun Flem, Laax e Falera",
            "    - tariffas d’indigens tier las purschidas publicas (lag da Cauma, center da sport e.a.v.)",
            "    - rabat d’indigens en fatschentas (sche la purschida)",
            "",
            "",
            "",
            "",
            "",
            "Beiliegend erhalten Sie Ihren neuen Einheimisch-Ausweis. Er ist fünf Jahre gültig (siehe rechter Kartenrand).",
            "",
            "Mit dem Einheimisch-Ausweis können Sie unter anderem folgende Leistungen in Anspruch nehmen:",
            "",
            "    - als Bestätigung Ihres Einheimischen-Status",
            "    - Vergünstigte Abonnemente und Tickets bei den Bergbahnen Flims-Laax-Falera",
            "    - mehrheitlich freie Fahrt mit dem öffentlichen Verkehr innerhalb der Destination Flims, Laax und Falera",
            "    - Einheimisch-Tarife bei öffentlichen Angeboten (Caumasee, Sportzentrum etc.)",
            "    - Einheimisch-Rabatt in Geschäften (falls angeboten)",
            "",
        ];
        doc.text(bodyText, 25, 119, { maxWidth: 190, align: "left", lineHeightFactor: 1 });
       const rmBodyTextBeforeLink = "Ulteriuras informaziuns anfleis Vus sut  ";
        const bodyTextBeforeLink = "Weitere Informationen finden Sie unter  ";
        const linkText = "www.einheimisch-ausweis.ch.";
        const linkWidth = doc.getTextWidth(linkText);
        const yPosition = 204;
        const rmYPosition = 154;
        doc.text(bodyTextBeforeLink, 25, yPosition, { maxWidth: 190, align: "left" });
        doc.text(rmBodyTextBeforeLink, 25, rmYPosition, { maxWidth: 190, align: "left" });

        const xLinkStart = doc.getTextWidth(bodyTextBeforeLink) + 25;
        const rmXLinkStart = doc.getTextWidth(rmBodyTextBeforeLink) + 25;

        doc.setTextColor(0, 0, 255);
        doc.setFont("Helvetica", "normal");
        doc.text(linkText, doc.getTextWidth(bodyTextBeforeLink) + 25, yPosition);
        doc.text(linkText, doc.getTextWidth(rmBodyTextBeforeLink) + 25, rmYPosition);

        doc.setFont("Helvetica", "normal");
        doc.setTextColor(0, 0, 0);

        doc.line(xLinkStart, yPosition + 1, xLinkStart + linkWidth, yPosition + 1);
        doc.line(rmXLinkStart, rmYPosition + 1, rmXLinkStart + linkWidth, rmYPosition + 1);

        // Closing
        doc.text("salids amicabels / Freundliche Grüsse", 112, 227);
        doc.setFont("Helvetica", "bold");
        doc.text("vischnaunca Falera / Gemeinde Falera", 112, 232);
        doc.setFont("Helvetica", "normal");
        doc.text("controlla d‘habitonts / Einwohnerkontrolle", 112, 236);
        doc.text(senderFirstname + ' ' + senderLastname, 112, 259);
    };

    const createFlimsLetter = async (letter: LetterData, doc: jsPDF) =>
    {
        const { title, firstname, lastname, address, plz, city, senderFirstname, senderLastname } = letter;

        const date = new Date();
        const day = date.getDate();
        const month = new Intl.DateTimeFormat('de-DE', { month: 'long' }).format(date);
        const year = date.getFullYear();
        const currentDate = `${day}. ${month} ${year}`;
        doc.setFont("Helvetica", "normal");
        doc.setFontSize(8);

        doc.setDrawColor(128,128,128);
        doc.setLineWidth(0.25);
        doc.line(160, 25, 186, 25);
        doc.setTextColor(128,128,128);
        doc.setFont("Helvetica", "bold");
        doc.text("Einwohnerkontrolle", 160, 28, { align: "left" });
        doc.setFont("Helvetica", "normal");
        doc.text("Via dil Casti 2", 160, 32, { align: "left" });
        doc.text("CH-7017 Flims Dorf", 160, 36, { align: "left" });
        doc.text("Tel. +41 81 928 29 29", 160, 40, { align: "left" });
        doc.text("www.gemeindeflims.ch", 160, 44, { align: "left" });

        doc.setTextColor(0);
        doc.setFontSize(11);

        doc.text(title, 25, 60);
        doc.text(firstname + ' ' + lastname, 25, 64);
        doc.text(address, 25, 68);
        doc.text(plz + ' ' + city, 25, 72);


        doc.setFontSize(6);
        doc.text(senderFirstname + ' ' + senderLastname, 160, 60, { align: "left" });
        doc.text("Tel. +41 81 928 29 29", 160, 63, { align: "left" });
        doc.text("Einwohnerdienste@gemeindeflims.ch", 160, 66, { align: "left" });

        doc.setFontSize(11);

        // Date
        doc.text('Flims' + ', ' + currentDate, 25, 100);

        // Subject
        doc.setFontSize(13);
        doc.setFont("Helvetica", "bold");
        doc.text("Einheimisch-Ausweis", 25, 115);

        // Greeting
        doc.setFontSize(11);
        doc.setFont("Helvetica", "normal");
        const preTitle = ({ Herr: "geehrter", Frau: "geehrte" })[title as string] || "";

        doc.text("Sehr " + preTitle + ' ' + title + ' ' + lastname, 25, 130);

        // Body Content
        const bodyText = [
            "In der Beilage überlassen wir Ihnen den neuen Einheimisch-Ausweis.",
            "Er ist fünf Jahre gültig (s. rechter Kartenrand).",
            "",
            "Den Einheimisch-Ausweis können Sie u.a. für die verschiedensten Dienstleistungen einsetzen:",
            "- als Bestätigung des Einheimischstatus",
            "- Einheimischrabattierung in Geschäften (falls angeboten)",
            "- Bezug von vergünstigten Abonnements und Tickets bei den Bergbahnen",
            "- Mehrheitlich kostenloser öV Transport innerhalb der Destination Flims, Laax und Falera",
            "- Einheimischtarife bei öffentlichen Angeboten (Caumasee, Sportzentrum etc.)",
        ];
        doc.text(bodyText, 25, 140, { maxWidth: 190, align: "left", lineHeightFactor: 1.25 });
        const bodyTextBeforeLink = "Unter ";
        const linkText = "www.einheimisch-ausweis.ch";
        const bodyTextAfterLink = " finden Sie weitere Erläuterungen.";

        doc.text(bodyTextBeforeLink, 25, 187, { maxWidth: 190, align: "left" });

        const xLinkStart = doc.getTextWidth(bodyTextBeforeLink) + 25;
        const yPosition = 187;

        doc.setTextColor(0, 0, 255);
        doc.setFont("Helvetica", "normal");
        doc.text(linkText, doc.getTextWidth(bodyTextBeforeLink) + 25, 187);

        doc.setFont("Helvetica", "normal");
        doc.setTextColor(0, 0, 0);
        doc.text(bodyTextAfterLink, doc.getTextWidth(bodyTextBeforeLink) + doc.getTextWidth(linkText) + 25, 187, {
            maxWidth: 190,
            align: "left",
        });

        const linkWidth = doc.getTextWidth(linkText);
        doc.setDrawColor(0, 0, 255); // Set line color to blue
        doc.line(xLinkStart, yPosition + 1, xLinkStart + linkWidth, yPosition + 1);

        // Closing
        doc.text("Freundliche Grüsse", 25, 205);
        doc.text(senderFirstname + ' ' + senderLastname, 25, 235);
        doc.text("Einwohnerkontrolle", 25, 240);
    };

    return {
        createFlimsLetter: createFlimsLetter,
        createFaleraLetter: createFaleraLetter,
        createLaaxLetter: createLaaxLetter,
        createLetter: createLetter,
    };
};
